import {
  combineReducers,
  createReducer,
  on,
}                       from '@ngrx/store';
import {
  addBeneficiary,
  addPayment,
  addPaymentError,
  addPaymentResult,
  assignDocument,
  assignDocumentError,
  assignDocumentSuccess,
  checkDuplicatePayments,
  checkDuplicatePaymentsError,
  checkDuplicatePaymentsResult,
  clearAiarInfo,
  clearDuplicatePayments,
  closeDialog,
  createAiar,
  createAiarAuthorization,
  createAiarAuthorizationError,
  createAiarAuthorizationResult,
  createAiarError,
  createAiarResult,
  createClient,
  createClientError,
  createClientResult,
  createIsabelAuthorization,
  createIsabelAuthorizationError,
  createIsabelAuthorizationSuccess,
  deleteBeneficiary,
  deleteDocument,
  deleteDocumentError,
  deleteDocumentSuccess,
  downloadDocument,
  downloadDocumentError,
  downloadDocumentResult,
  editBeneficiariesError,
  editBeneficiariesResult,
  fetchAccountsWithWarningBadgeCountResult,
  fetchAccountUserResult,
  fetchAiarInfo,
  fetchAiarInfoError,
  fetchAiarInfoResult,
  fetchAssignDocumentClientsResult,
  fetchClientBadgeCountResult,
  fetchClientBeneficiaries,
  fetchClientBeneficiariesError,
  fetchClientBeneficiariesResult,
  fetchColorModeResult,
  fetchDocumentAssignmentData,
  fetchDocumentAssignmentDataError,
  fetchDocumentBadgeCountResult,
  fetchDocumentPaymentData,
  fetchDocumentPaymentDataError,
  fetchDocumentProcessingData,
  fetchDocumentProcessingDataError,
  fetchGlobalBeneficiaries,
  fetchGlobalBeneficiariesError,
  fetchGlobalBeneficiariesResult,
  fetchInfoAssignDocumentDialogError,
  fetchInfoAssignDocumentDialogResult,
  fetchInfoPaymentDialog,
  fetchInfoPaymentDialogError,
  fetchInfoPaymentDialogResult,
  fetchInfoProcessDocumentDialogError,
  fetchInfoProcessDocumentDialogResult,
  fetchInfoXs2aDialog,
  fetchInfoXs2aDialogError,
  fetchInfoXs2aDialogResult,
  fetchMaintenanceModeResult,
  fetchNewBudgetAppEnabledError,
  fetchNewBudgetAppEnabledResult,
  fetchNotificationBadgeCountResult,
  fetchOfficeResult,
  fetchPaymentAccountsResult,
  fetchPaymentBadgeCountResult,
  fetchPaymentClientsResult,
  fetchUnlinkedAccountsBadgeCountResult,
  fetchUserSettingsResult,
  reloadPage,
  renameDocument,
  renameDocumentError,
  renameDocumentSuccess,
  respondToDocument,
  respondToDocumentError,
  respondToDocumentResult,
  setAssignDocument,
  setColorModeResult,
  setDocumentHidden,
  setDocumentHiddenError,
  setDocumentHiddenSuccess,
  setDocumentShared,
  setDocumentSharedError,
  setDocumentSharedSuccess,
  setPaymentDocument,
  setProcessDocument,
  setUserSettingsResult,
  setViewDocument,
  startSelectingDocuments,
  stopSelectingDocuments,
  updateBeneficiary,
  updatePayment,
  updatePaymentError,
  updatePaymentResult,
}                       from './app.actions';
import { initialState } from './app.state';

const colorModeReducer = createReducer(
  initialState.colorMode,
  on(fetchColorModeResult, (state, { colorMode }) => colorMode),
  on(setColorModeResult, (state, { colorMode }) => colorMode),
);

const maintenanceModeReducer = createReducer(
  initialState.maintenanceMode,
  on(fetchMaintenanceModeResult, (state, { maintenanceMode }) => maintenanceMode),
);

const accountUserReducer = createReducer(
  initialState.accountUser,
  on(fetchAccountUserResult, (state, { user }) => user),
);

const userSettingsReducer = createReducer(
  initialState.userSettings,
  on(fetchUserSettingsResult, (state, { userSettings }) => userSettings),
  on(setUserSettingsResult, (state, { userSettings }) => userSettings),
);

const clientBadgeCountReducer = createReducer(
  initialState.clientBadgeCount,
  on(fetchClientBadgeCountResult, (state, { count }) => count),
);

const notificationBadgeCountReducer = createReducer(
  initialState.notificationBadgeCount,
  on(fetchNotificationBadgeCountResult, (state, { count }) => count),
);

const paymentBadgeBadgeCountReducer = createReducer(
  initialState.paymentBadgeCount,
  on(fetchPaymentBadgeCountResult, (state, { count }) => count),
);

const unlinkedAccountsBadgeCountReducer = createReducer(
  initialState.unlinkedAccountsBadgeCount,
  on(fetchUnlinkedAccountsBadgeCountResult, (state, { count }) => count),
);

const accountsWithWarningBadgeCountReducer = createReducer(
  initialState.accountsWithWarningBadgeCount,
  on(fetchAccountsWithWarningBadgeCountResult, (state, { count }) => count),
);

const documentBadgeBadgeCountReducer = createReducer(
  initialState.documentBadgeCount,
  on(fetchDocumentBadgeCountResult, (state, { count }) => count),
);

const officeReducer = createReducer(
  initialState.office,
  on(fetchOfficeResult, (state, { office }) => office),
);

const newBudgetAppEnabledReducer = createReducer(
  initialState.newBudgetAppEnabled,
  on(fetchNewBudgetAppEnabledResult, (state, { enabled }) => enabled),
  on(fetchNewBudgetAppEnabledError, () => false),
);

const createClientIsLoadingReducer = createReducer(
  initialState.createClientIsLoading,
  on(createClient, () => true),
  on(createClientResult, () => false),
  on(createClientError, () => false),
);

const selectingDocumentsReducer = createReducer(
  initialState.selectingDocuments,
  on(startSelectingDocuments, () => true),
  on(stopSelectingDocuments, () => false),
  on(closeDialog, () => false),
  on(reloadPage, () => false),
);

const documentUpdatingReducer = createReducer(
  initialState.documentUpdating,
  on(respondToDocument, () => true),
  on(respondToDocumentResult, () => false),
  on(respondToDocumentError, () => false),
);

const documentDownloadingIdReducer = createReducer(
  initialState.documentDownloadingId,
  on(downloadDocument, (state, { id }) => id),
  on(downloadDocumentResult, () => null),
  on(downloadDocumentError, () => null),
);

const renameDocumentIsLoadingReducer = createReducer(
  initialState.renameDocumentIsLoading,
  on(renameDocument, () => true),
  on(renameDocumentSuccess, () => false),
  on(renameDocumentError, () => false),
);

const toggleDocumentHiddenIsLoadingIdReducer = createReducer(
  initialState.toggleDocumentHiddenIsLoadingId,
  on(setDocumentHidden, (state, { documentId }) => documentId),
  on(setDocumentHiddenSuccess, () => null),
  on(setDocumentHiddenError, () => null),
);

const toggleDocumentSharedIsLoadingIdReducer = createReducer(
  initialState.toggleDocumentSharedIsLoadingId,
  on(setDocumentShared, (state, { documentId }) => documentId),
  on(setDocumentSharedSuccess, () => null),
  on(setDocumentSharedError, () => null),
);

const deleteDocumentIsLoadingReducer = createReducer(
  initialState.deleteDocumentIsLoading,
  on(deleteDocument, () => true),
  on(deleteDocumentSuccess, () => false),
  on(deleteDocumentError, () => false),
);

const fetchingDocumentPaymentDataIdReducer = createReducer(
  initialState.fetchingDocumentPaymentDataId,
  on(fetchDocumentPaymentData, (state, { documentId }) => documentId),
  on(fetchDocumentPaymentDataError, () => null),
  on(fetchInfoPaymentDialogResult, () => null),
  on(fetchInfoPaymentDialogError, () => null),
);

const paymentAccountsReducer = createReducer(
  initialState.paymentAccounts,
  on(fetchInfoPaymentDialogResult, (state, { paymentAccounts }) => paymentAccounts ?? state),
  on(fetchInfoProcessDocumentDialogResult, (state, { paymentAccounts }) => paymentAccounts ?? state),
  on(fetchPaymentAccountsResult, (state, { paymentAccounts }) => paymentAccounts),
);

const paymentClientsReducer = createReducer(
  initialState.paymentClients,
  on(fetchInfoPaymentDialogResult, (state, { paymentClients }) => paymentClients ?? state),
  on(fetchInfoProcessDocumentDialogResult, (state, { paymentClients }) => paymentClients ?? state),
  on(fetchPaymentClientsResult, (state, { paymentClients }) => paymentClients),
);

const paymentDocumentTypeReducer = createReducer(
  initialState.paymentDocumentType,
  on(setPaymentDocument, (state, { documentType }) => documentType),
);

const paymentDocumentUrlReducer = createReducer(
  initialState.paymentDocumentUrl,
  on(setPaymentDocument, (state, { documentUrl }) => documentUrl),
);

const globalBeneficiariesReducer = createReducer(
  initialState.globalBeneficiaries,
  on(fetchInfoPaymentDialogResult, (state, { globalBeneficiaries }) => globalBeneficiaries),
  on(fetchInfoProcessDocumentDialogResult, (state, { globalBeneficiaries }) => globalBeneficiaries),
  on(fetchGlobalBeneficiariesResult, (state, { beneficiaries }) => beneficiaries),
  on(editBeneficiariesResult, (state, { globalBeneficiaries }) => globalBeneficiaries),
);

const clientBeneficiariesReducer = createReducer(
  initialState.clientBeneficiaries,
  on(fetchClientBeneficiaries, () => []),
  on(fetchInfoPaymentDialogResult, (state, { clientBeneficiaries }) => clientBeneficiaries),
  on(fetchInfoProcessDocumentDialogResult, (state, { clientBeneficiaries }) => clientBeneficiaries),
  on(fetchClientBeneficiariesResult, (state, { beneficiaries }) => beneficiaries),
  on(editBeneficiariesResult, (state, { clientBeneficiaries }) => clientBeneficiaries),
);

const globalBeneficiariesLoadingReducer = createReducer(
  initialState.globalBeneficiariesLoading,
  on(fetchGlobalBeneficiaries, () => true),
  on(fetchGlobalBeneficiariesResult, () => false),
  on(fetchGlobalBeneficiariesError, () => false),
);

const clientBeneficiariesLoadingReducer = createReducer(
  initialState.clientBeneficiariesLoading,
  on(fetchClientBeneficiaries, () => true),
  on(fetchClientBeneficiariesResult, () => false),
  on(fetchClientBeneficiariesError, () => false),
);

const paymentInfoLoadingReducer = createReducer(
  initialState.paymentInfoLoading,
  on(fetchInfoPaymentDialog, () => true),
  on(fetchInfoPaymentDialogResult, () => false),
  on(fetchInfoPaymentDialogError, () => false),
);

const paymentSavingReducer = createReducer(
  initialState.paymentSaving,
  on(addPayment, () => true),
  on(updatePayment, () => true),
  on(addPaymentResult, () => false),
  on(updatePaymentResult, () => false),
  on(addPaymentError, () => false),
  on(updatePaymentError, () => false),
);

const beneficiaryEditingReducer = createReducer(
  initialState.beneficiaryEditing,
  on(addBeneficiary, () => true),
  on(updateBeneficiary, () => true),
  on(deleteBeneficiary, () => true),
  on(editBeneficiariesError, () => false),
  on(editBeneficiariesResult, () => false),
);

const duplicatePaymentsTypeReducer = createReducer(
  initialState.duplicatePaymentsType,
  on(checkDuplicatePayments, () => null),
  on(checkDuplicatePaymentsResult, (state, { duplicatePaymentsType }) => duplicatePaymentsType),
  on(checkDuplicatePaymentsError, () => null),
  on(clearDuplicatePayments, () => null),
);

const duplicatePaymentsLatestDateReducer = createReducer(
  initialState.duplicatePaymentsLatestDate,
  on(checkDuplicatePayments, () => null),
  on(checkDuplicatePaymentsResult, (state, { duplicatePaymentsLatestDate }) => duplicatePaymentsLatestDate),
  on(checkDuplicatePaymentsError, () => null),
  on(clearDuplicatePayments, () => null),
);

const viewDocumentUrlReducer = createReducer(
  initialState.viewDocumentUrl,
  on(setViewDocument, (state, { documentUrl }) => documentUrl),
);

const viewDocumentTypeReducer = createReducer(
  initialState.viewDocumentType,
  on(setViewDocument, (state, { documentType }) => documentType),
);

const fetchingDocumentAssignmentDataIdsReducer = createReducer(
  initialState.fetchingDocumentAssignmentDataIds,
  on(fetchDocumentAssignmentData, (state, { documents }) => documents.map(d => d.id)),
  on(fetchDocumentAssignmentDataError, () => []),
  on(fetchInfoAssignDocumentDialogResult, () => []),
  on(fetchInfoAssignDocumentDialogError, () => []),
);

const assignDocumentTypeReducer = createReducer(
  initialState.assignDocumentType,
  on(setAssignDocument, (state, { documentType }) => documentType),
);

const assignDocumentUrlReducer = createReducer(
  initialState.assignDocumentUrl,
  on(setAssignDocument, (state, { documentUrl }) => documentUrl),
);

const assignDocumentClientsReducer = createReducer(
  initialState.assignDocumentClients,
  on(fetchInfoAssignDocumentDialogResult, (state, { clients }) => clients ?? state),
  on(fetchInfoProcessDocumentDialogResult, (state, { assignDocumentClients }) => assignDocumentClients ?? state),
  on(fetchAssignDocumentClientsResult, (state, { clients }) => clients),
);

const assignDocumentIsLoadingReducer = createReducer(
  initialState.assignDocumentIsLoading,
  on(assignDocument, () => true),
  on(assignDocumentSuccess, () => false),
  on(assignDocumentError, () => false),
);

const fetchingDocumentProcessingDataReducer = createReducer(
  initialState.fetchingDocumentProcessingData,
  on(fetchDocumentProcessingData, () => true),
  on(fetchDocumentProcessingDataError, () => false),
  on(fetchInfoProcessDocumentDialogResult, () => false),
  on(fetchInfoProcessDocumentDialogError, () => false),
);

const processDocumentTypeReducer = createReducer(
  initialState.processDocumentType,
  on(setProcessDocument, (state, { documentType }) => documentType),
);

const processDocumentUrlReducer = createReducer(
  initialState.processDocumentUrl,
  on(setProcessDocument, (state, { documentUrl }) => documentUrl),
);

const xs2aInfoIsLoadingReducer = createReducer(
  initialState.xs2aInfoIsLoading,
  on(fetchInfoXs2aDialog, () => true),
  on(fetchInfoXs2aDialogResult, () => false),
  on(fetchInfoXs2aDialogError, () => false),
);

const xs2aFinancialInstitutionsReducer = createReducer(
  initialState.xs2aFinancialInstitutions,
  on(fetchInfoXs2aDialogResult, (state, { financialInstitutions }) => financialInstitutions),
);

const aiarInfoIsLoadingReducer = createReducer(
  initialState.aiarInfoIsLoading,
  on(fetchAiarInfo, () => true),
  on(fetchAiarInfoResult, () => false),
  on(fetchAiarInfoError, () => false),
);

const aiarInfoReducer = createReducer(
  initialState.aiarInfo,
  on(fetchAiarInfoResult, (state, { aiarInfo }) => aiarInfo),
  on(clearAiarInfo, () => null),
);

const createAiarIsLoadingReducer = createReducer(
  initialState.createAiarIsLoading,
  on(createAiar, () => true),
  on(createAiarResult, () => false),
  on(createAiarError, () => false),
);

const createAiarAuthorizationIsLoadingReducer = createReducer(
  initialState.createAiarAuthorizationIsLoading,
  on(createAiarAuthorization, () => true),
  on(createAiarAuthorizationResult, () => false),
  on(createAiarAuthorizationError, () => false),
);

const aiarAuthorizationReducer = createReducer(
  initialState.aiarAuthorization,
  on(createAiarAuthorizationResult, (state, { aiarAuthorization }) => aiarAuthorization),
);

const aiarAuthorizationErrorReducer = createReducer(
  initialState.aiarAuthorizationError,
  on(createAiarAuthorizationError, () => true),
);

const createIsabelAuthorizationIsLoadingReducer = createReducer(
  initialState.createIsabelAuthorizationIsLoading,
  on(createIsabelAuthorization, () => true),
  on(createIsabelAuthorizationSuccess, () => false),
  on(createIsabelAuthorizationError, () => false),
);

const isabelAuthorizationErrorReducer = createReducer(
  initialState.isabelAuthorizationError,
  on(createIsabelAuthorizationError, () => true),
);

export const appReducer = combineReducers(
  {
    colorMode: colorModeReducer,
    maintenanceMode: maintenanceModeReducer,
    accountUser: accountUserReducer,
    userSettings: userSettingsReducer,
    clientBadgeCount: clientBadgeCountReducer,
    notificationBadgeCount: notificationBadgeCountReducer,
    paymentBadgeCount: paymentBadgeBadgeCountReducer,
    unlinkedAccountsBadgeCount: unlinkedAccountsBadgeCountReducer,
    accountsWithWarningBadgeCount: accountsWithWarningBadgeCountReducer,
    documentBadgeCount: documentBadgeBadgeCountReducer,
    office: officeReducer,
    createClientIsLoading: createClientIsLoadingReducer,
    documentUpdating: documentUpdatingReducer,
    documentDownloadingId: documentDownloadingIdReducer,
    selectingDocuments: selectingDocumentsReducer,
    renameDocumentIsLoading: renameDocumentIsLoadingReducer,
    toggleDocumentHiddenIsLoadingId: toggleDocumentHiddenIsLoadingIdReducer,
    toggleDocumentSharedIsLoadingId: toggleDocumentSharedIsLoadingIdReducer,
    deleteDocumentIsLoading: deleteDocumentIsLoadingReducer,
    fetchingDocumentPaymentDataId: fetchingDocumentPaymentDataIdReducer,
    paymentAccounts: paymentAccountsReducer,
    paymentClients: paymentClientsReducer,
    paymentDocumentType: paymentDocumentTypeReducer,
    paymentDocumentUrl: paymentDocumentUrlReducer,
    globalBeneficiaries: globalBeneficiariesReducer,
    clientBeneficiaries: clientBeneficiariesReducer,
    globalBeneficiariesLoading: globalBeneficiariesLoadingReducer,
    clientBeneficiariesLoading: clientBeneficiariesLoadingReducer,
    paymentInfoLoading: paymentInfoLoadingReducer,
    paymentSaving: paymentSavingReducer,
    beneficiaryEditing: beneficiaryEditingReducer,
    duplicatePaymentsType: duplicatePaymentsTypeReducer,
    duplicatePaymentsLatestDate: duplicatePaymentsLatestDateReducer,
    viewDocumentType: viewDocumentTypeReducer,
    viewDocumentUrl: viewDocumentUrlReducer,
    fetchingDocumentAssignmentDataIds: fetchingDocumentAssignmentDataIdsReducer,
    assignDocumentType: assignDocumentTypeReducer,
    assignDocumentUrl: assignDocumentUrlReducer,
    assignDocumentClients: assignDocumentClientsReducer,
    assignDocumentIsLoading: assignDocumentIsLoadingReducer,
    fetchingDocumentProcessingData: fetchingDocumentProcessingDataReducer,
    processDocumentType: processDocumentTypeReducer,
    processDocumentUrl: processDocumentUrlReducer,
    xs2aInfoIsLoading: xs2aInfoIsLoadingReducer,
    xs2aFinancialInstitutions: xs2aFinancialInstitutionsReducer,
    aiarInfoIsLoading: aiarInfoIsLoadingReducer,
    aiarInfo: aiarInfoReducer,
    createAiarIsLoading: createAiarIsLoadingReducer,
    createAiarAuthorizationIsLoading: createAiarAuthorizationIsLoadingReducer,
    aiarAuthorization: aiarAuthorizationReducer,
    aiarAuthorizationError: aiarAuthorizationErrorReducer,
    createIsabelAuthorizationIsLoading: createIsabelAuthorizationIsLoadingReducer,
    isabelAuthorizationError: isabelAuthorizationErrorReducer,
    newBudgetAppEnabled: newBudgetAppEnabledReducer,
  },
  initialState,
);
